import { TermStepEnum } from "../../Terms/enums/termStep.enum";
import { TermStepTranslatorEnum } from "../../Terms/enums/termStepTranslator.enum";

import { FiltersProps } from "@/core/libs/list-data/lib/filters/interfaces";
import { ListDataFiltersTypeEnum } from "@/core/libs/list-data/lib/interfaces/enums";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";

const removeMask = (value: string) => {
  return value?.replace(/\D/g, "");
};

interface BuildComplementaryDocumentsFiltersProps {
  servicesList: { key: number; text: string }[];
  isLoadingServicesList: boolean;
}

export function buildComplementaryDocumentsFilters({
  servicesList,
  isLoadingServicesList
}: BuildComplementaryDocumentsFiltersProps) {
  const termsFilters: FiltersProps[] = [
    {
      label: "Nome",
      placeholder: "Nome",
      filterQuery: "fullName",
      type: ListDataFiltersTypeEnum.TEXT,
      maxWidth: "200px"
    },
    {
      label: "CPF/CNPJ",
      placeholder: "CPF/CNPJ",
      filterQuery: "documentNumber",
      type: ListDataFiltersTypeEnum.TEXT,
      maxWidth: "200px",
      maskFormatter: cpfCnpjFormatter,
      valueFormatter: removeMask
    },
    {
      label: "Unidade de Negócio",
      placeholder: "Unidade de Negócio",
      filterQuery: "businessUnitName",
      type: ListDataFiltersTypeEnum.TEXT,
      maxWidth: "200px"
    },
    {
      label: "Benefício",
      placeholder: "Benefício",
      filterQuery: "serviceId",
      type: ListDataFiltersTypeEnum.SELECT,
      options: !isLoadingServicesList && servicesList,
      minWidth: "300px"
    },
    {
      label: "Termos criados entre",
      filterQuery: ["beginsAt", "finishesAt"],
      type: ListDataFiltersTypeEnum.DATE_RANGE
    },
    {
      label: "Estado",
      placeholder: "Estado",
      filterQuery: "currentStep",
      type: ListDataFiltersTypeEnum.SELECT,
      minWidth: "200px",
      options: [
        {
          key: TermStepEnum.TIMED_OUT,
          text: TermStepTranslatorEnum.TIMED_OUT
        },
        {
          key: TermStepEnum.REGISTER_CORRECTION,
          text: TermStepTranslatorEnum.REGISTER_CORRECTION
        },
        {
          key: TermStepEnum.MEMBER_SIGNED,
          text: TermStepTranslatorEnum.MEMBER_SIGNED
        },
        {
          key: TermStepEnum.OPTIONAL_SIGNATURES_COLLECTED,
          text: TermStepTranslatorEnum.OPTIONAL_SIGNATURES_COLLECTED
        },
        {
          key: TermStepEnum.CANCELED,
          text: TermStepTranslatorEnum.CANCELED
        },
        {
          key: TermStepEnum.DONE,
          text: TermStepTranslatorEnum.DONE
        },
        {
          key: TermStepEnum.REJECTED,
          text: TermStepTranslatorEnum.REJECTED
        }
      ]
    }
  ];

  return termsFilters;
}
